import Button from "../../components/NewButton";
import "./Start.css";
import AppContext from "../../context/AppContext";
import Caracteristicas from "../VistasInicio/Caracteristicas";
import { Col, Row } from "react-bootstrap";
import ImgInicio from "../../assets/Inicio.webp";
import ImgMenu from "../../assets/Menu.webp";
import Planes from "../VistasInicio/Planes";
import ImgMenu2 from "../../assets/Menu2.webp";
import ImgSeleccion from "../../assets/Seleccion.webp";
import ImgCarrito from "../../assets/Carrito.webp";
import ImgDetalle from "../../assets/Detalle.webp";
import EmblaCarousel from "../../components/carousel/EmblaCarousel";

const OPTIONS = { loop: true, duration: 25 };
const SLIDES = [
  ImgInicio,
  ImgMenu,
  ImgMenu2,
  ImgSeleccion,
  ImgCarrito,
  ImgDetalle,
];

export default function Start() {
  if (AppContext.user && !AppContext.register) {
    window.location.href = "/signup";
  } else {
    return (
      <>
        <section id="inicio">
          <div className="start">
            <Row style={{ marginTop: "30px" }}>
              <Col
                md={8}
                style={{
                  textAlign: "center",
                  alignSelf: "center",
                  paddingRight: "30px",
                  paddingLeft: "30px",
                }}
              >
                <h1 style={{ fontWeight: "bold" }}>
                  TRANSFORMA TU
                  <br />
                  SERVICIO CON RAPDIS
                </h1>
                <h5 style={{ marginBottom: "30px" }}>
                  La app todo-en-uno para agilizar tu restaurante, mejorar la
                  experiencia del cliente y aumentar tus ventas. <br />
                  <br />
                  ¡Desde food trucks hasta restaurantes de gran escala!
                </h5>
                <Row style={{ justifyContent: "center" }}>
                  <Button
                    redirectTo={"/caracteristicas"}
                    text={"Solicita tu DEMO"}
                    filled={true}
                  ></Button>
                  <Button redirectTo={"/"} text={"¡Descargala ahora!"}></Button>
                </Row>
              </Col>
              <Col
                md={4}
                style={{
                  alignItems: "center",
                  alignSelf: "center",
                  padding: "30px",
                }}
                className="theme-dark"
              >
                <EmblaCarousel slides={SLIDES} options={OPTIONS} />
                {/* <img
                  style={{
                    alignSelf: "center",
                    borderRadius: "20px",
                    imageRendering: "",
                  }}
                  alt=""
                  className="image-start"
                  src={Imageinit}
                ></img> */}
              </Col>
            </Row>
            {/* <img alt="" className="image-start" src={Show}></img> */}
          </div>
          <h5
            style={{ textAlign: "center", padding: "40px" }}
            className="start"
          >
            Somos la clave para transformar tu negocio. Optimiza la
            comunicación, agiliza los pedidos y eleva la experiencia de tus
            clientes con una herramienta hecha a la medida de tus necesidades.
            Personaliza cada función y haz que la eficiencia y atención en tu
            restaurante crezcan exponencialmente.
          </h5>
        </section>
        <section id="caracteristicas">
          <Caracteristicas />
        </section>
        <section className="theme-dark" id="nosotros">
          {/* <Nosotros /> */}
        </section>
        <section id="planes">
          <Planes />
        </section>
        <section id="casos">{/* <Casos /> */}</section>
      </>
    );
  }
}
